import { apiMipe } from '@/core/api/';

const apiUrl = 'api/medicalplan';

export const getPlanTypes = () => apiMipe.get(`${apiUrl}/planTypes`);
export const get = (sie) => apiMipe.get(`${apiUrl}/${sie}`);
export const save = (sie, payload) => apiMipe.post(`${apiUrl}/${sie}`, payload);
export const getHistory = (sie, params) =>
  apiMipe.get(`${apiUrl}/${sie}/history`, { params });

export const saveConsent = (payload) =>
  apiMipe.post(`${apiUrl}/consent`, payload);
export const searchConsent = (params) =>
  apiMipe.get(`${apiUrl}/consent`, { params });
export const getConsent = (id) => apiMipe.get(`${apiUrl}/consent/${id}`);
export const getConsentByStudent = (studentsieid) =>
  apiMipe.get(`${apiUrl}/consent/bystudent/${studentsieid}`);
export const saveMechanism = (consentId, isElectronicSignature) =>
  apiMipe.put(
    `${apiUrl}/consent/mechanism/${consentId}/${isElectronicSignature}`
  );
export const saveSignedDocument = (payload) =>
  apiMipe.post(`${apiUrl}/consent/signed-document`, payload);
export const markSigned = (consentId) =>
  apiMipe.put(`${apiUrl}/consent/mark-signed/${consentId}`);
